/* THIS FILE IS GENERATED ON RUNTIME. DO NOT EDIT */

import { ComponentClassNameFactory } from 'lib/contexts/ComponentClassNameFactory';
import getPropStylesFactory from 'lib/utils/getPropStylesFactory';
import getComponentStylesFactory from 'lib/utils/getComponentStylesFactory';
import getComponentThemeFactory from 'lib/utils/getComponentThemeFactory';
import make_styler from '../index';

export const styles = {
  "reel_colors_default": "",
  "reel_size_default": "text-headline-xs",
  "reel_variant_default": "uppercase italic animate-loop",
  "colors_default": "bg-primary-700 text-primary-100",
  "size_default": "py-1",
  "variant_default": "flex flex-row flex-nowrap overflow-hidden whitespace-nowrap"
};

const c = make_styler(styles);

export const propClassName = getPropStylesFactory(c, styles, "LoopAround");

export const componentClassName = getComponentStylesFactory(propClassName);

export const componentTheme = getComponentThemeFactory(styles);

export const {
  ClassNameContext,
  ClassNameProvider,
  useClassName,
  useTheme,
} = ComponentClassNameFactory(componentClassName, styles);
  
export default c;